module.exports = __webpack_public_path__ + "img/Home-Logged-In.6413f9fc.svg";